export { Size } from '../../../es/_util/enum';
export var WaitType;
(function (WaitType) {
    WaitType["throttle"] = "throttle";
    WaitType["debounce"] = "debounce";
})(WaitType || (WaitType = {}));
export var Tooltip;
(function (Tooltip) {
    Tooltip["none"] = "none";
    Tooltip["always"] = "always";
    Tooltip["overflow"] = "overflow";
})(Tooltip || (Tooltip = {}));
export var FieldFocusMode;
(function (FieldFocusMode) {
    FieldFocusMode["checked"] = "checked";
    FieldFocusMode["focus"] = "focus";
})(FieldFocusMode || (FieldFocusMode = {}));
